import styled, { keyframes, css } from "styled-components";

const changedAnimation = (backgroundColor) => keyframes`
  0% {
    background-color: transparent;
  }
  25% {
    background-color: ${backgroundColor};
    transform: scale(1.02);
  }
  100% {
    background-color: transparent;
  }
`;
const PageWrapper = styled.div`
  width: fit-content;
  border-radius: 6px;
  transition: all 0.2s;
  animation: "";
  ${(props) =>
    props.editable &&
    `
    cursor: pointer;
    user-select: none;
    &:hover {
      background-color: ${props.dark ? "#44424C" : "#f2f2f2"};
    };
  `}
`;
const PageSelectorWrapper = styled.div`
  position: relative;
  ${PageWrapper} {
    animation: ${(props) =>
      props.isChangedAnimation
        ? css`
            ${changedAnimation(props.dark ? "#44424C" : "#f2f2f2")} .5s ease-in-out
          `
        : ""};
  }
`;
const Editor = styled.div`
  position: relative;
  height: 100%;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const SearchBarWrapper = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  padding: 5px;
  background: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 5px;
`;
const Pages = styled.div`
  padding: 50px 5px 0px;
`;
const PageLink = styled.a`
  display: flex;
  border-radius: 4px;
  margin-left: 5px;
  &:hover {
    background-color: #dedede;
  }
  svg {
    width: 20px;
    height: 20px;
  }
`;
const Page = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  padding: 3px;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 6px;
  width: 100%;
  background-color: ${(props) => (props.selected ? "#f6f6ff" : "#fff")};
  ${(props) =>
    props.selected &&
    `
    padding: 4px;
    position: sticky;
    top: 50px;
    bottom: 0px;
  `};
  &:hover {
    background-color: ${(props) => (props.selected ? "#f6f6ff" : "#f2f2f2")};
  }
`;

const PageLinksWrapper = styled.div`
  position: absolute;
  right: 5px;
  display: flex;
`;

const ButtonSmallSecondary = styled.button`
  background: white;
  border: 2px solid #8066ff;
  border-radius: 4px;
  color: #8066ff;
  cursor: pointer;
  font-family: Public Sans;
  white-space: nowrap;
  font-style: normal;
  font-size: 14px;
  transition: all 0.3s;
  width: 32px;
  height: 32px;
`;

export {
  PageWrapper,
  PageSelectorWrapper,
  Editor,
  SearchBarWrapper,
  Pages,
  PageLink,
  Page,
  PageLinksWrapper,
  ButtonSmallSecondary
};
